import { Villa, STATUS_LABELS } from '../types';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from './ui/sheet';
import { Card, CardContent } from './ui/card';
import { RotateCcw } from 'lucide-react';
import { Button } from './ui/button';

interface ArchiveDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  villas: Villa[];
  onRestore: (id: string) => void;
}

export default function ArchiveDrawer({
  open,
  onOpenChange,
  villas,
  onRestore,
}: ArchiveDrawerProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="h-[85vh] flex flex-col">
        <SheetHeader>
          <SheetTitle>Архивные ({villas.length})</SheetTitle>
        </SheetHeader>

        <div className="flex-1 mt-4 space-y-3 overflow-y-auto -mx-6 px-6">
          {villas.map((villa) => (
            <Card key={villa.id} className="overflow-hidden">
              <CardContent className="p-3">
                <div className="flex gap-3">
                  {/* Thumbnail */}
                  {villa.image ? (
                    <div className="w-20 h-20 flex-shrink-0 rounded overflow-hidden">
                      <img
                        src={villa.image}
                        alt={villa.title || ''}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className="w-20 h-20 flex-shrink-0 rounded bg-muted flex items-center justify-center">
                      <span className="text-2xl">🏠</span>
                    </div>
                  )}

                  {/* Info */}
                  <div className="flex-1 min-w-0">
                    <h4 className="font-medium text-sm line-clamp-2">
                      {villa.title || villa.domain}
                    </h4>
                    <p className="text-xs text-muted-foreground mt-1">
                      {STATUS_LABELS[villa.status]}
                    </p>
                    {villa.priceFormatted && (
                      <p className="text-sm font-semibold text-green-600 dark:text-green-400">
                        {villa.priceFormatted}
                      </p>
                    )}
                  </div>
                </div>

                {/* Restore Button - full width below */}
                <Button
                  variant="outline"
                  className="w-full mt-3"
                  onClick={() => onRestore(villa.id)}
                >
                  <RotateCcw className="h-4 w-4 mr-2" />
                  Вернуть из архива
                </Button>
              </CardContent>
            </Card>
          ))}

          {villas.length === 0 && (
            <div className="text-center py-10 text-muted-foreground">
              Архив пуст
            </div>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
